module.exports = __webpack_public_path__ + "static/media/card-bg2@2x.83e8777b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/card-bg2@2x.png
// module id = 996
// module chunks = 0